var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsp03(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_57_230)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 43,
    r: 23,
    fill: "#58B947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.0436 43.9921H32.5923C31.9226 43.9921 31.3749 44.5604 31.3749 45.2552V54.7357C31.3749 55.4306 31.9226 55.9989 32.5923 55.9989H41.1855C41.4716 55.9989 41.4716 55.679 41.4716 55.679V44.42C41.4716 44.4212 41.4716 43.9921 41.0436 43.9921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4076 43.9921H43.9653C43.4508 43.9921 43.5284 44.5477 43.5284 44.5477V55.6905C43.5284 55.6905 43.524 55.9989 43.8333 55.9989H52.4076C53.0773 55.9989 53.6251 55.4306 53.6251 54.7357V45.2552C53.6251 44.5604 53.0773 43.9921 52.4076 43.9921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4716 36.5329C41.4716 36.5329 41.4716 36.1049 41.0636 36.1049H31.2175C30.5477 36.1049 30 36.6732 30 37.3669V41.3105C30 42.0053 30.5477 42.5736 31.2175 42.5736H41.0979C41.4727 42.5736 41.4727 42.2366 41.4727 42.2366V36.5329H41.4716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7825 36.1049H43.9043C43.5284 36.1049 43.5284 36.4765 43.5284 36.4765V42.2446C43.5284 42.2446 43.5284 42.5736 43.9852 42.5736H53.7825C54.4522 42.5736 55 42.0053 55 41.3105V37.3669C55 36.6732 54.4522 36.1049 53.7825 36.1049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3314 35.1696C36.7747 35.1696 36.2658 35.1236 35.819 35.0327C34.6858 34.8026 33.9063 34.3563 33.4373 33.666C33.017 33.0471 32.8884 32.2856 33.0547 31.4009C33.3463 29.8525 34.3498 29 35.8777 29C36.2015 29 36.5563 29.0391 36.9333 29.115C37.8924 29.3095 39.1198 29.8801 40.2164 30.6416C42.0759 31.9335 42.1679 32.7365 42.0759 33.2289C41.9395 33.9513 41.2886 34.4679 40.0845 34.8084C39.2706 35.0385 38.2672 35.1696 37.3314 35.1696ZM35.8777 31.0247C35.2856 31.0247 35.0827 31.1961 34.9707 31.7897C34.8798 32.2752 34.9951 32.4443 35.0328 32.5007C35.1914 32.7331 35.6027 32.9275 36.1937 33.0471C36.512 33.1115 36.9056 33.1461 37.3314 33.1461C38.2683 33.1461 39.0921 32.9988 39.6399 32.8378C39.6798 32.8262 39.7419 32.7779 39.6753 32.7365C38.9602 32.1326 37.6507 31.325 36.5607 31.1029C36.3046 31.0512 36.0751 31.0247 35.8777 31.0247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6975 35.1696C46.7606 35.1696 45.7571 35.0385 44.9444 34.8084C43.7402 34.469 43.0893 33.9513 42.9541 33.2289C42.8609 32.7377 42.953 31.9335 44.8135 30.6416C45.909 29.8812 47.1364 29.3095 48.0956 29.115C48.4725 29.038 48.8285 29 49.1511 29C50.6802 29 51.6814 29.8524 51.973 31.402C52.1393 32.2867 52.0107 33.0494 51.5916 33.6672C51.1226 34.3574 50.3431 34.8049 49.2099 35.0339C48.7642 35.1236 48.2552 35.1696 47.6975 35.1696ZM45.3701 32.7227C45.3069 32.7607 45.3369 32.8216 45.3701 32.8308C45.9168 32.9942 46.7506 33.1449 47.6975 33.1449C48.1233 33.1449 48.5169 33.1104 48.8362 33.046C49.4261 32.9263 49.8386 32.7319 49.9971 32.4995C50.0348 32.4443 50.1502 32.2741 50.0581 31.7897C49.9461 31.1961 49.7432 31.0247 49.1511 31.0247C48.9527 31.0247 48.7242 31.0512 48.4703 31.1018C47.3782 31.3227 46.0853 32.1176 45.3701 32.7227Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_57_230",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_57_230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_57_230",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "white",
    transform: "translate(30 29)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsp03);
export default __webpack_public_path__ + "static/media/usp03.ec1d9a2c48386dc632e343b4a1d9e7e8.svg";
export { ForwardRef as ReactComponent };